import { useDispatch } from "react-redux";
import { UIactions } from "../../../../../store/slices/UI";
import Button from "../../../../UI/GeneralPurpose/Button";

const UIText = {
  "es-CL": { label: "Cerrar" },
  "en-US": { label: "Close" },
};

const Close = ({ modal }) => {
  const dispatch = useDispatch();

  const onClick = () => {
    if (modal === "1") {
      dispatch(UIactions.closeModal());
    } else if (modal === "2") {
      dispatch(UIactions.closeModal2());
    }
  };

  return <Button {...{ UIText, onClick }} />;
};

export default Close;
